<div class="card"  (click)="goto($event, defaultLink)">
    <div class="clear"  *ngIf="auth.canDelete(this.auth.user$ | async) && showDelete" (click)="deleteHandler($event)">
        <mat-icon>clear</mat-icon>
    </div>
    <div class="clear" *ngIf="auth.canEdit(this.auth.user$ | async) && showEdit" (click)="updateHandler($event)">
        <mat-icon>edit</mat-icon>
    </div>
    <div class="thumb"></div>
    <div class="card-container">
        <div class="actions">
            <div class="action" *ngFor="let actionButton of actionButtons;  let i = index">
                <mat-icon [ngClass]="actionButton['hoverColor']" [matTooltip]="actionButton['tooltip']" (click)="actionTriggeredHandler($event, i, defaultLink, actionButton['relativeUrl']? actionButton['relativeUrl']:actionButton['url'] )">{{actionButton['icon']}}</mat-icon>
            </div>
        </div>
        <h5 [matTooltip]="title"> {{title.length>30 ? (title | slice:0:30)+'...' : title}}</h5>
       

        <div class="content">
            <ng-content></ng-content>
        </div>
        
    </div>
</div>